{
  "fr": {
    "profile": {
      "actions": {
        "changeEmail": "Changez votre email",
        "changeEmailAddress": "Changer l'adresse email",
        "delete": "Supprimer",
        "installApp": "Installer l'application 🚀",
        "launchApp": "Lancer l'application",
        "save": "Enregistrer",
        "showQRCode": "Afficher le code QR"
      },
      "attributes": {
        "decimal_separator": "Notation de devise décimale",
        "email_address": "Email",
        "email_address_new": "Nouvelle adresse email",
        "email_address_old": "Ancienne adresse e-mail"
      },
      "labels": {
        "addToHomeScreen": "Ajouter à l'écran d'accueil",
        "allowAccess": "Donnez à Ziggu l'accès à votre compte",
        "allowImpersonation": "Approuver l'accès à Ziggu",
        "allowImpersonationSubtext": "Il se peut que nous devions accéder temporairement à votre compte pour diagnostiquer et résoudre un problème de support client que vous avez soulevé. Notre accès expire automatiquement après 7 jours.",
        "allowRecording": "Autoriser l'enregistrement de session",
        "allowRecordingSubtext": "L'enregistrement de votre session dans Ziggu pourrait nous aider à trouver la cause d'un problème que vous avez soulevé. L'enregistrement s'arrête automatiquement après 60 minutes ou quand vous désactivez ce paramètre.",
        "and_x_other": "et 1 autre | et {other_count} autres",
        "bulk_invite_help": "Nous inviterons les contacts sélectionnés sur la plateforme. Cela peut prendre quelques minutes.",
        "changeEmailAddress": "Changer addresse email de {profile_name}",
        "checkYourInbox": "Nous avons envoyé un email à {email_address} pour confirmer",
        "confirmEmailUpdate": "L'email contient un lien pour compléter le processus de mise à jour. Contactez-nous si vous rencontrez des problèmes.",
        "confirmPasswordReset": "Un email a été envoyé avec un lien pour réinitialiser votre mot de passe, veuillez vérifier votre boîte de réception. Contactez-nous si vous rencontrez des problèmes.",
        "currency": {
          "comma": "Virgule: 200.450,99",
          "point": "Point: 200,450.99"
        },
        "delete_info": "Voulez-vous vraiment supprimer cet utilisateur? Cette action supprimera toutes les données utilisateur sensibles et empêchera l'utilisateur de se connecter et de recevoir des e-mails plus longtemps",
        "delete_user": "Supprimer {user_name}",
        "emailAddressNewConfirm": "Confirmer nouvelle adresse email",
        "emailNotificationsInterval": "Fréquence des e-mails pour les nouvelles notifications",
        "emailNotificationsIntervalSubtext": "Ici, vous pouvez définir la fréquence à laquelle vous souhaitez que la plateforme vérifie s'il y a des mises à jour pour vous et vous envoie un e-mail à ce sujet.",
        "explainerSendEmail": "Un nouvel email d’invitation sera envoyé à {name}",
        "explainerUpdateEmailActive": "{name} est déjà actif sur la plateforme. Un e-mail sera envoyé à la nouvelle adresse avec un lien pour confirmer le changement d'adresse e-mail.",
        "explainerUpdateEmailInvited": "{name} a déjà été invité. Une nouvelle invitation sera envoyée à la nouvelle adresse e-mail. Toutes les invitations précédentes seront non fonctionnelles.",
        "followDevicePrompts": "Suivez les instructions de votre appareil pour ajouter l'application à votre écran d'accueil",
        "impersonateProfile": "Imiter {profile_name}",
        "important": "Important",
        "importantContent": "Assurez-vous d'être connecté à la plateforme sur votre appareil mobile via le navigateur web.",
        "installMobileApp": "Installer l'application mobile",
        "logInMobileDevice": "Connectez-vous sur votre appareil mobile",
        "maintainerCannotImpersonatePartner": "Seuls les collègues avec le rôle Propriétaire peuvent imiter des partenaires.",
        "maintainerCannotUpdateEmailAddress": "Seuls les collègues avec le rôle Propriétaire peuvent modifier l'adresse e-mail du client.",
        "multipleProfiles": "Cet utilisateur possède plusieurs comptes Ziggu. Seul l'utilisateur peut modifier l'adresse e-mail.",
        "mustBeLoggedInBeforeQR": "Vous devez être connecté sur votre appareil mobile avant de scanner le code QR",
        "noEmailAddressAdded": "Aucune adresse e-mail ajoutée",
        "onceLoggedInScan": "Une fois connecté, scannez le code QR pour installer l'application sur votre appareil",
        "openMobileBrowser": "Ouvrez votre navigateur mobile et visitez",
        "public_api_access": "Jeton d'accès à l'API publique",
        "redirectAutomatically": "Vous serez automatiquement redirigé dans {seconds} secondes",
        "requestPasswordReset": "Réinitialiser votre mot de passe",
        "scanQRCode": "Scanner le code QR",
        "toLogInCredentials": "pour vous connecter avec vos données d'identification",
        "updateEmailFailed": "Votre adresse e-mail n'a pas été mise à jour. Veuillez réessayer ou contactez-nous.",
        "updateEmailSuccessful": "Votre adresse email a été mise à jour avec succès",
        "updateFailed": "La mise à jour a échoué. Veuillez réessayer ou nous contacter.",
        "writeProfileNameReject": "Ecrivez <i><b>{profile_name}</b></i> pour continuer."
      },
      "notifications": {
        "avatarChangedSuccessfully": "L'avatar a été mis à jour. Les modifications peuvent prendre jusqu'à une heure pour être visibles."
      },
      "toasts": {
        "bulk_invite": "Nous avons commencé à inviter les contacts sélectionnés sur la plateforme",
        "emailResendSuccessfully": "Email renvoyé avec succès"
      },
      "validation": {
        "emailAddressBounce": {
          "hard_bounce": "L'adresse e-mail n'existe pas/plus, veuillez changer l'adresse e-mail.",
          "illegal_address": "Adresse e-mail illégale : l'adresse e-mail que vous fournissez n'est peut-être pas configurée correctement, veuillez vous assurer que l'adresse e-mail est correctement formatée et ne contient aucun caractère illégal.",
          "isp_block": "Blocage FAI: un blocage signifie généralement que notre adresse IP ou notre serveur a été rejeté par le serveur de messagerie de réception.",
          "soft_bounce": "La personne est absente du bureau ou la boîte de réception est pleine et n'accepte pas les e-mails.",
          "spam_complaint": "La personne a cliqué sur \"Marquer comme spam\" dans son client de messagerie, cette adresse e-mail a été désactivée. Si le destinataire vous contacte et souhaite recevoir à nouveau des e-mails, contactez-nous.",
          "spam_notification": "Les e-mails ont été rejetés par le serveur de messagerie. Cela peut être dû à des politiques d'entreprise rigides en place sur le serveur de messagerie de réception ou à un mauvais choix de mots dans votre e-mail qui sont signalés par des filtres anti-spam."
        },
        "emailAddressBounced": "Erreur d'adresse e-mail",
        "emailDoesntMatch": "L'address email ne correspond pas",
        "emailTaken": "L'adresse email a déjà été utilisée",
        "mustBeEmailAddress": "Adresse email valide requis",
        "requireEmailAddress": "Email requis",
        "tooManyRequests": "Un seul changement d'adresse e-mail autorisé toutes les 5 minutes. Réessayez plus tard."
      }
    }
  }
}